import React, { useState, useEffect } from 'react'
import { Button, makeStyles, Paper } from '@material-ui/core'
import rolePermissionGroupService from '../../../../services/rolePermissionGroup.service'

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        padding: theme.spacing(2),
    },
    enhancedTableToolbar: {
        width: '100%',

        '& .MuiToolbar-gutters': {
            paddingRight: 16,
        },
    },
    toolBar: {
        float: 'right',
    },
    tableSection: {
        marginTop: 25,
    },
    formControl: {
        minWidth: 120,
        maxWidth: 300,
    },
    rule: {
        paddingTop: 10,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 10,
        marginBottom: 20,
    },
    buttonRight: {
        marginLeft: 10,
    },
}))

const Rules = () => {
    const classes = useStyles()
    const [userGroupPermissions, setUserGroupPermissions] = useState([])
    const [
        userGroupPermissionAnswers,
        setUserGroupPermissionAnswers,
    ] = useState([])

    useEffect(() => {
        ;(async function getPageData() {
            try {
                await rolePermissionGroupService
                    .getAllPermissions()
                    .then(result => {
                        setUserGroupPermissions(result)
                        setFakePermissionAnswers(result)
                    })
            } catch (exception) {
                console.log(exception)
            }
        })()
    }, [])

    const setFakePermissionAnswers = rules => {
        let defaultedRules = rules.map(it => ({
            id: it.userPermissionTypeId,
            value: true,
        }))

        setUserGroupPermissionAnswers(defaultedRules)
    }

    const setRuleAnswer = (ruleId, answerValue) => {
        const elementIndex = userGroupPermissions.findIndex(
            it => it.parentUserPermissionId === ruleId
        )
        let newArray = [...userGroupPermissions]
        newArray[elementIndex] = {
            ...newArray[elementIndex],
            isVisible: !answerValue,
        }
        setUserGroupPermissions(newArray)
        console.log(userGroupPermissions)
    }

    function ParentRule({ rule }) {
        return (
            <Paper className={classes.rule}>
                <h3>{rule.description}</h3>
                <>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={() => {
                            setRuleAnswer(rule.userPermissionTypeId, true)
                        }}>
                        Yes
                    </Button>
                    <Button
                        className={classes.buttonRight}
                        variant='contained'
                        color='secondary'
                        onClick={() => {
                            setRuleAnswer(rule.userPermissionTypeId, false)
                        }}>
                        No
                    </Button>

                    {userGroupPermissions
                        .filter(
                            it =>
                                it.parentUserPermissionId ===
                                    rule.userPermissionTypeId && it.isVisible
                        )
                        .map(it => {
                            return (
                                <h3 key={`childrule-${it.orderBy}`}>
                                    {it.description}
                                </h3>
                            )
                        })}
                </>
            </Paper>
        )
    }

    return (
        <>
            {userGroupPermissions
                .filter(it => it.parentUserPermissionId == null)
                .map(it => {
                    return (
                        <ParentRule
                            key={`parentrule-${it.orderBy}`}
                            rule={it}
                        />
                    )
                })}
        </>
    )
}

export default Rules
